import { EmailAttachment } from 'types/domain';

interface AttachmentsProps {
    list: EmailAttachment[];
}

const Attachments = ({ list = [] }: AttachmentsProps) => {
    if (!list.length) return null;
    return (
        <div className="flex flex-grow flex-col">
            {list.map(item => (
                <a
                    key={item.url}
                    href={item.url}
                    rel="noreferrer"
                    target="_blank"
                    className="flex text-blue-500 no-underline"
                >
                    {item.name}
                </a>
            ))}
        </div>
    );
};

export { Attachments };
